










import { Vue, Component, Prop } from 'vue-property-decorator';
import * as config from './config';
import { namespace, State, Action } from 'vuex-class';

const Module = namespace('HealthContributionBrand2019');
@Component({
  components: {},
})
export default class FirstPage extends Vue {
  @Module.Action changehealthType!: (index: number) => void;
  options = config.OPTHINES;
  enterPage(type: any) {
    this.changehealthType(type);
    this.$router.push({
      path: './List',
      query: { type: type as any },
    });
  }
}
